import React, { useState } from 'react';

const ResultsHeader = ({ displayedSearchQuery, searchTime, totalMedicines, totalDocuments, totalImages, fileTypeCounts, matchedTerms = [], includeTermFrequencies, showSearchOverview, onToggleSearchOverview }) => {
  // State to manage showing all terms
  const [isExpanded, setIsExpanded] = useState(false);
  const INITIAL_TERM_LIMIT = 10; // Change this number to show more/fewer by default

  const termTotals = matchedTerms.reduce((acc, terms) => {
    if (Array.isArray(terms)) {
      terms.forEach(([term, count]) => {
        acc[term] = (acc[term] || 0) + count;
      });
    }
    return acc;
  }, {});

  const sortedTerms = Object.entries(termTotals).sort(([, a], [, b]) => b - a);
  const displayedTerms = isExpanded ? sortedTerms : sortedTerms.slice(0, INITIAL_TERM_LIMIT);
  const hasMore = sortedTerms.length > INITIAL_TERM_LIMIT;

  return (
    <div className="search-results-summary">
      <div className="results-header-top">
        <div className="results-header-title" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <h2 style={{ margin: 0 }}>Search Results:</h2>
          <i>{displayedSearchQuery}</i>
          <span>({searchTime && searchTime >= 0.001 ? searchTime.toFixed(3) : "<0.001"}s)</span>
        </div>

        <button
          className={`docshark-overview-toggle-button ${showSearchOverview ? 'open' : ''}`}
          onClick={onToggleSearchOverview}
          aria-expanded={showSearchOverview}
          aria-label={showSearchOverview ? 'Hide quick overview' : 'Show quick overview'}
        >
          <span>{showSearchOverview ? 'Hide distribution' : 'Show distribution'}</span>
          <i className={`bx bx-chevron-${showSearchOverview ? 'up' : 'down'}`}></i>
        </button>
      </div>

      <div className="results-overview">
        <div className="total-results-grid">
          <div className="total-result-item"><span className="result-count">{totalMedicines}</span><span className="result-label"><h2>Medicines with hits</h2></span></div>
          <div className="total-result-item"><span className="result-count">{totalDocuments}</span><span className="result-label"><h2>Documents found</h2></span></div>
          {totalImages > 0 && (<div className="total-result-item"><span className="result-count">{totalImages}</span><span className="result-label"><h2>Images in documents</h2></span></div>)}
        </div>
        <div className="results-by-type">
          {['epar', 'decision', 'annex', 'other'].map(type => (fileTypeCounts[type] && (
            <div className="file-type-result" key={type}><span className={`file-type-bubble file-type-${type.toLowerCase()}`}>{fileTypeCounts[type]}</span><span className="file-type-label">{type}</span></div>
          )))}
        </div>
      </div>

      {includeTermFrequencies && sortedTerms.length > 0 && (
          <div className="terms-overview">
            <div className="terms-header-row">
              <h3>Total Word Frequencies:</h3>
              {hasMore && (
                <button 
                  className="terms-toggle-link" 
                  onClick={() => setIsExpanded(!isExpanded)}
                >
                  {isExpanded ? 'Show less found words' : `Show all found words (${sortedTerms.length})`}
                </button>
              )}
            </div>
            <div className="terms-overview-grid">
              {displayedTerms.map(([term, count]) => (
                <div key={term} className="term-overview-item">
                  <span className="term-name">{term}</span>
                  <span className="term-total-count">{count}</span>
                </div>
              ))}
            </div>
          </div>
        )}
    </div>
  );
};

export default ResultsHeader;